export const getCompleteVehicleModel = (params: {
  modelDescription: string;
  motor: string;
  version: string;
  initialYear: number;
  endYear: number;
}): string => {
  const years = `(${params.initialYear || ""} - ${params.endYear || ""})`;

  const datas: string[] = [];
  datas.push(params.modelDescription);
  datas.push(params.motor);
  datas.push(params.version);
  datas.push(years);

  return datas.filter((s) => s).join(" ");
};
